// Providers
import { BrowserRouter } from 'react-router-dom'
import { WalletProvider } from './WalletProvider'
import { SafePOKTProvider } from './SafePOKTProvider'
import { SpendableTokenProvider } from './SpendableTokenProvider'
import { WpoktMintControllerProvider } from './WpoktMintControllerProvider'
import { ToastProvider } from './ToastProvider'

interface AppProvidersProps {
  children: React.ReactNode
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <WalletProvider>
          <SpendableTokenProvider>
            <SafePOKTProvider> <WpoktMintControllerProvider>{children}</WpoktMintControllerProvider></SafePOKTProvider>
          </SpendableTokenProvider>
        </WalletProvider>
      </ToastProvider>
    </BrowserRouter>
  )
}
